import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Webhook icon component for the Webhook Wait action type in selectors and lists.
 */
import { Webhook } from "lucide-react";
/**
 * Icon component for the webhook wait step type.
 * @param root0 - The component props
 * @param root0.className - CSS class name for styling
 * @returns The Webhook icon from lucide-react
 */
export function Icon({ className }) {
    return _jsx(Webhook, { className: className });
}
//# sourceMappingURL=Icon.js.map